import React, { useEffect } from 'react';

import { userActions } from '../../actions';

import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';

function Account() {
  const dispatch = useDispatch();

  const usersState = useSelector(state => state.users);
  let user = usersState.edit;

  useEffect(() => {
    dispatch(userActions.editAccount());
  }, [dispatch, usersState.account]);

  function handleChange(e) {
    const { name, value } = e.target;
    dispatch(userActions.setEditAccount(({ ...user, [name]: value })));
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (isValidForm()) {
      dispatch(userActions.patchAccount(user));
    }
  }

  function isValidForm() {
    return user && (user.nom && user.prenom && user.email);
  }

  return (
    <div className="bloc-reservation">
      <h2 className="bloc-reservation__title">
        <span className="bloc-reservation__icon">
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-15-raquette" />
          </svg>
        </span>
          Mon compte
      </h2>
      {(usersState.account && usersState.account.abonnement) &&
        <div className="bloc-reservation__item no-hover">
          {!usersState.account.dateAbonnement
            ?
            <div>
              Crédit restant&nbsp;: <strong className={usersState.account.credit <= 0 ? 'error' : ''}>
                {usersState.account.credit}
              </strong>
            </div>
            :
            <div>
              Date de fin d'abonnement&nbsp;: <strong className={moment.unix(usersState.account.dateAbonnement).isBefore() ? 'error' : ''}>
                {moment.unix(usersState.account.dateAbonnement).format('DD MMMM YYYY')}
              </strong>
            </div>
          }

        </div>
      }
      <form className="form form--account clearfix" noValidate onSubmit={handleSubmit}>
        <div className="form__inner">
          <div className="form-group">
            <label htmlFor="nom">Nom *</label>
            <input type="text" id="nom" name="nom" value={user ? user.nom : ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="prenom">Prénom *</label>
            <input type="text" id="prenom" name="prenom" value={user ? user.prenom : ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input type="email" id="email" name="email" value={user ? user.email : ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="telephone">Téléphone</label>
            <input type="tel" id="telephone" name="telephone" value={user ? user.telephone : ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="pass">Mot de passe</label>
            <input type="password" id="pass" name="pass" onChange={handleChange} />
            <span className="info">6 caractères minimum</span>
          </div>
          <div className="form-group">
            <label htmlFor="passConfirm">Confirmation du mot de passe</label>
            <input type="password" id="passConfirm" name="passConfirm" onChange={handleChange} />
            <span className="info">6 caractères minimum</span>
          </div>
          <div className="form-group">
            <label htmlFor="adresse">Adresse</label>
            <input type="text" id="adresse" name="adresse" value={user ? user.adresse : ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="cp">Code postal</label>
            <input type="text" id="cp" name="cp" value={user ? user.cp : ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="ville">Ville</label>
            <input type="text" id="city" name="ville" value={user ? user.ville : ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="dateNaissance">Date de naissance</label>
            <input type="text" id="dateNaissance" name="dateNaissance" placeholder="jj/mm/aaaa" value={user ? user.dateNaissance : ''} onChange={handleChange} />
            <span className="info">format jj/mm/aaaa</span>
          </div>
        </div>
        <button disabled={!isValidForm()} className="btn btn--no-icon btn--submit">Sauvegarder</button>
      </form>
    </div>
  );
}

export default Account;
